<template>
    <section id="rooms">
        <div class="room-section white-bg">

            <div class="room">
                <div class="content">
                    <h2 class="content-title">{{$t('roomStandard.title')}}</h2>
                    <p class="content-description">
                        {{$t('roomStandard.textTop')}}
                    </p>
                    <div class="room-info">
                        <!--<div class="room-info-content">-->
                        <!--<h4 class="room-info-title">Цена</h4>-->
                        <!--<p>960 <span>грн</span></p>-->
                        <!--</div>-->
                        <div class="room-info-content">
                            <div class="room-info-title">{{$t('roomStandard.areaTitle')}}</div>
                            <p>20 <span>{{$t('roomStandard.areaDescription')}}</span></p>
                        </div>
                        <div class="room-info-content">
                            <div class="room-info-title">{{$t('roomStandard.guests')}}</div>
                            <p>1-2 <span>{{$t('roomStandard.guestDescription')}}</span></p>
                        </div>
                    </div>
                    <div class="content-buttons">
                        <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]+ '?room-type=17704'" class="orange-btn">{{$t('buttons.btn1')}}</a>
                        <a href="#modal_standart" class="border-btn open-modal" @click="viewItem({ id: 17704, name: 'Стандарт' })">{{$t('buttons.more')}}</a>
                        <div class="m-buttons-wrap">
                            <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]+ '?room-type=17704'" class="orange-btn">{{$t('booking.title')}}</a>
                            <a
                                href="#modal_lux"
                                class="border-btn open-modal"
                                @click="
                                    changeButtonText('standart')
                                    details_opened.standart
                                        ? viewItem({ id: 17704, name: 'Стандарт' })
                                        : () => {}
                                "
                            >
                                {{details_opened.standart ? $t('buttons.hide') : $t('buttons.more')}}
                            </a>
                        </div>
                        <div class="accordion">
                            <div class="in-number">
                                <h2 class="title">{{$t('accommodation.accommodation')}}</h2>
                                <p>
                                    {{$t('accommodation.double_bed')}} /
                                    {{$t('accommodation.two_beds')}},
                                    {{$t('accommodation.secretaire')}},
                                    {{$t('accommodation.conditioner')}},
                                    {{$t('accommodation.tv')}},
                                    {{$t('accommodation.telephone')}},
                                    {{$t('accommodation.safe')}},
                                    {{$t('accommodation.minibar')}},
                                    {{$t('accommodation.luggage')}},
                                    {{$t('accommodation.hangers')}},
                                    {{$t('accommodation.chair')}},
                                    {{$t('accommodation.wardrobe')}},
                                    {{$t('accommodation.mirror')}},
                                    {{$t('accommodation.wifi')}}
                                </p>
                            </div>
                            <div class="in-bathroom">
                                <h2 class="title">{{$t('bathroom.bathroom')}}</h2>
                                <p>
                                    {{$t('bathroom.shower')}},
                                    {{$t('bathroom.hairdryer')}},
                                    {{$t('bathroom.towels')}},
                                    {{$t('bathroom.slippers')}},
                                    {{$t('bathroom.toiletries')}}
                                </p>
                            </div>
                            <div class="info">
                                <h2 class="title">{{$t('services.services')}}</h2>
                                <p>
                                    {{$t('services.arrival')}},
                                    {{$t('services.departure')}},
                                    {{$t('services.concierge')}},
                                    {{$t('services.laundry')}},
                                    {{$t('services.restaurant_full')}},
                                    {{$t('services.lobby')}},
                                    {{$t('services.roomService')}},
                                    {{$t('services.conferenceService')}},
                                    {{$t('services.mall')}}
                                </p>
                            </div>
                            <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]+ '?room-type=17704'" class="mob-reserv">{{$t('buttons.btn1')}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="room room-image-st">
              <div class="slick-carousel">
                <div>
                  <img src="/img/Standart/1.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Standart/2.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Standart/3.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Standart/4.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Standart/5.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Standart/6.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Standart/7.jpg" alt="">
                </div>
<!--                <div>-->
<!--                  <img src="/img/Standart/8.jpg" alt="">-->
<!--                </div>-->
                <div>
                  <img src="/img/Standart/9.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Standart/10.jpg" alt="">
                </div>
              </div>
                <div class="m-slider">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img data-src="img/standart-m/1.jpg" class="swiper-lazy" alt="Стандарт">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/standart-m/2.jpg" class="swiper-lazy" alt="Стандарт (2)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/standart-m/3.jpg" class="swiper-lazy" alt="Стандарт (3)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/standart-m/4.jpg" class="swiper-lazy" alt="Стандарт (4)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/standart-m/5.jpg" class="swiper-lazy" alt="Стандарт (5)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/standart-m/6.jpg" class="swiper-lazy" alt="Стандарт (6)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/standart-m/7.jpg" class="swiper-lazy" alt="Стандарт (7)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
<!--                            <div class="swiper-slide">-->
<!--                                <img data-src="img/standart-m/8.jpg" class="swiper-lazy" alt="Стандарт (8)">-->
<!--                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>-->
<!--                            </div>-->
                            <div class="swiper-slide">
                                <img data-src="img/standart-m/9.jpg" class="swiper-lazy" alt="Стандарт (9)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/standart-m/10.jpg" class="swiper-lazy" alt="Стандарт (10)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                        </div>
                        <!-- Add Pagination -->
                        <div class="swiper-pagination swiper-pagination-white"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="room-section gray-bg">
            <div class="room room-image-in">
                <div class="slick-carousel">
                    <div>
                      <img src="/img/Improved/1.jpg" alt="">
                    </div>
                    <div>
                      <img src="/img/Improved/2.jpg" alt="">
                    </div>
                    <div>
                      <img src="/img/Improved/3.jpg" alt="">
                    </div>
                    <div>
                      <img src="/img/Improved/4.jpg" alt="">
                    </div>
                    <div>
                      <img src="/img/Improved/5.jpg" alt="">
                    </div>
                    <div>
                      <img src="/img/Improved/6.jpg" alt="">
                    </div>
                    <div>
                      <img src="/img/Improved/7.jpg" alt="">
                    </div>
                    <div>
                      <img src="/img/Improved/8.jpg" alt="">
                    </div>
                    <div>
                      <img src="/img/Improved/9.jpg" alt="">
                    </div>
                    <div>
                      <img src="/img/Improved/10.jpg" alt="">
                    </div>
                </div>
                <div class="m-slider">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img data-src="img/improved-m/1.jpg" class="swiper-lazy" alt="Улучшенный">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/improved-m/2.jpg" class="swiper-lazy" alt="Улучшенный (2)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/improved-m/3.jpg" class="swiper-lazy" alt="Улучшенный (3)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/improved-m/4.jpg" class="swiper-lazy" alt="Улучшенный (4)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/improved-m/5.jpg" class="swiper-lazy" alt="Улучшенный (5)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/improved-m/6.jpg" class="swiper-lazy" alt="Улучшенный (6)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/improved-m/7.jpg" class="swiper-lazy" alt="Улучшенный (7)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/improved-m/8.jpg" class="swiper-lazy" alt="Улучшенный (8)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/improved-m/9.jpg" class="swiper-lazy" alt="Улучшенный (9)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/improved-m/10.jpg" class="swiper-lazy" alt="Улучшенный (10)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                        </div>
                        <div class="swiper-pagination swiper-pagination-white"></div>
                    </div>
                </div>
            </div>
            <div class="room">
                <div class="content">
                    <h2 class="content-title">{{$t('roomDeluxe.title')}}</h2>
                    <p class="content-description">
                        {{$t('roomDeluxe.textTop')}}
                    </p>
                    <div class="room-info">
                        <!--<div class="room-info-content">-->
                        <!--<h4 class="room-info-title">Цена</h4>-->
                        <!--<p>1200 <span>грн</span></p>-->
                        <!--</div>-->
                        <div class="room-info-content">
                            <div class="room-info-title">{{$t('roomDeluxe.areaTitle')}}</div>
                            <p>21 <span>{{$t('roomDeluxe.areaDescription')}}</span></p>
                        </div>
                        <div class="room-info-content">
                            <div class="room-info-title">{{$t('roomDeluxe.guests')}}</div>
                            <p>1-2 <span>{{$t('roomDeluxe.guestDescription')}}</span></p>
                        </div>
                    </div>
                    <div class="content-buttons">
                        <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`] + '?room-type=17705'" class="orange-btn">{{$t('buttons.btn1')}}</a>
                        <a href="#modal_improved" class="border-btn open-modal" @click="viewItem({ id: 17705, name: 'Покращений' })">{{$t('buttons.more')}}</a>
                        <div class="m-buttons-wrap">
                            <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`] + '?room-type=17705'" class="orange-btn">{{$t('booking.title')}}</a>
                            <a
                                href="#modal_lux"
                                class="border-btn open-modal"
                                @click="
                                  changeButtonText('deluxe'),
                                  details_opened.deluxe
                                    ? viewItem({ id: 17705, name: 'Покращений' })
                                    : () => {}
                                "
                            >
                                {{details_opened.deluxe ? $t('buttons.hide') : $t('buttons.more')}}
                            </a>
                        </div>
                        <div class="accordion">
                            <div class="in-number">
                                <h2 class="title">{{$t('accommodation.accommodation')}}</h2>
                                <p>
                                    {{$t('accommodation.double_bed')}} /
                                    {{$t('accommodation.two_beds')}},
                                    {{$t('accommodation.conditioner')}},
                                    {{$t('accommodation.tv')}},
                                    {{$t('accommodation.telephone')}},
                                    {{$t('accommodation.safe')}},
                                    {{$t('accommodation.minibar')}},
                                    {{$t('accommodation.luggage')}},
                                    {{$t('accommodation.hangers')}},
                                    {{$t('accommodation.secretaire')}},
                                    {{$t('accommodation.chair')}},
                                    {{$t('accommodation.mirror')}},
                                    {{$t('accommodation.wardrobe')}},
                                    {{$t('accommodation.wifi')}}
                                </p>
                            </div>
                            <div class="in-bathroom">
                                <h2 class="title">{{$t('bathroom.bathroom')}}</h2>
                                <p>
                                    {{$t('bathroom.shower')}},
                                    {{$t('bathroom.hairdryer')}},
                                    {{$t('bathroom.towels')}},
                                    {{$t('bathroom.slippers')}},
                                    {{$t('bathroom.toiletries')}}
                                </p>
                            </div>
                            <div class="info">
                                <h2 class="title">{{$t('services.services')}}</h2>
                                <p>
                                    {{$t('services.arrival')}},
                                    {{$t('services.departure')}},
                                    {{$t('services.concierge')}},
                                    {{$t('services.laundry')}},
                                    {{$t('services.restaurant_full')}},
                                    {{$t('services.lobby')}},
                                    {{$t('services.roomService')}},
                                    {{$t('services.conferenceService')}},
                                    {{$t('services.mall')}}
                                </p>
                            </div>
                            <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`] + '?room-type=17705'" class="mob-reserv">{{$t('buttons.btn1')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="room-section white-bg">
            <div class="room">
                <div class="content">
                    <h2 class="content-title">{{$t('roomLux.title')}}</h2>
                    <p class="content-description">
                        {{$t('roomLux.textTop')}}
                    </p>
                    <div class="room-info">
                        <!--<div class="room-info-content">-->
                        <!--<h4 class="room-info-title">Цена</h4>-->
                        <!--<p>1500 <span>грн</span></p>-->
                        <!--</div>-->
                        <div class="room-info-content">
                            <div class="room-info-title">{{$t('roomLux.areaTitle')}}</div>
                            <p>40 <span>{{$t('roomLux.areaDescription')}}</span></p>
                        </div>
                        <div class="room-info-content">
                            <div class="room-info-title">{{$t('roomLux.guests')}}</div>
                            <p>1-4 <span>{{$t('roomLux.guestDescription')}}</span></p>
                        </div>
                    </div>
                    <div class="content-buttons">
                        <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]  + '?room-type=17708,17710'" class="orange-btn">{{$t('buttons.btn1')}}</a>
                        <a href="#modal_lux" class="border-btn open-modal" @click="viewItem({ id: 17708, name: 'Люкс' })">{{$t('buttons.more')}}</a>
                        <div class="m-buttons-wrap">
                            <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]  + '?room-type=17708,17710'" class="orange-btn">{{$t('buttons.btn1')}}</a>
                            <a
                                href="#modal_lux"
                                class="border-btn open-modal"
                                @click="
                                  changeButtonText('suite')
                                  details_opened.suite
                                    ? viewItem({ id: 17708, name: 'Люкс' })
                                    : () => {}
                                "
                            >
                                {{details_opened.suite ? $t('buttons.hide') : $t('buttons.more')}}
                            </a>
                        </div>
                        <div class="accordion">
                            <div class="in-number">
                                <h2 class="title">{{$t('accommodation.accommodation')}}</h2>
                                <p>
                                    {{$t('accommodation.kingsize')}},
                                    {{$t('accommodation.sofa')}},
                                    {{$t('accommodation.table')}},
                                    {{$t('accommodation.secretaire')}},
                                    {{$t('accommodation.conditioner')}},
                                    {{$t('accommodation.tv')}},
                                    {{$t('accommodation.telephone')}},
                                    {{$t('accommodation.safe')}},
                                    {{$t('accommodation.minibar')}},
                                    {{$t('accommodation.luggage')}},
                                    {{$t('accommodation.hangers')}},
                                    {{$t('accommodation.chair')}},
                                    {{$t('accommodation.wardrobe')}},
                                    {{$t('accommodation.mirror_big')}},
                                    {{$t('accommodation.wifi')}}
                                </p>
                            </div>
                            <div class="in-bathroom">
                                <h2 class="title">{{$t('bathroom.bathroom')}}</h2>
                                <p>
                                    {{$t('bathroom.shower')}} /
                                    {{$t('bathroom.bathroom')}},
                                    {{$t('bathroom.hairdryer')}},
                                    {{$t('bathroom.towels')}},
                                    {{$t('bathroom.bath robes')}},
                                    {{$t('bathroom.slippers')}},
                                    {{$t('bathroom.toiletries')}}
                                </p>
                            </div>
                            <div class="info">
                                <h2 class="title">{{$t('services.services')}}</h2>
                                <p>
                                    {{$t('services.arrival')}},
                                    {{$t('services.departure')}},
                                    {{$t('services.concierge')}},
                                    {{$t('services.laundry')}},
                                    {{$t('services.restaurant_full')}},
                                    {{$t('services.lobby')}},
                                    {{$t('services.roomService')}},
                                    {{$t('services.conferenceService')}},
                                    {{$t('services.mall')}}
                                </p>
                            </div>
                            <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]  + '?room-type=17708,17710'" class="mob-reserv">{{$t('buttons.btn1')}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="room room-image-lux">
              <div class="slick-carousel">
                <div>
                  <img src="/img/Lux/1.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Lux/2.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Lux/3.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Lux/4.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Lux/5.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Lux/6.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Lux/7.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Lux/8.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Lux/9.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Lux/10.jpg" alt="">
                </div>
              </div>
                <div class="m-slider">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img data-src="img/lux-m/1.jpg" class="swiper-lazy" alt="Люкс">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/lux-m/2.jpg" class="swiper-lazy" alt="Люкс (2)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/lux-m/3.jpg" class="swiper-lazy" alt="Люкс (3)">
                                <div class="swiper-lazy-preloader swijpg-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/lux-m/4.jpg" class="swiper-lazy" alt="Люкс (4)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/lux-m/5.jpg" class="swiper-lazy" alt="Люкс (5)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/lux-m/6.jpg" class="swiper-lazy" alt="Люкс (6)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/lux-m/7.jpg" class="swiper-lazy" alt="Люкс (7)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/lux-m/8.jpg" class="swiper-lazy" alt="Люкс (8)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/lux-m/9.jpg" class="swiper-lazy" alt="Люкс (9)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/lux-m/10.jpg" class="swiper-lazy" alt="Люкс (10)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                        </div>
                        <!-- Add Pagination -->
                        <div class="swiper-pagination swiper-pagination-white"></div>
                    </div>

                </div>
            </div>
        </div>

        <div class="room-section gray-bg">
            <div class="room room-image-studio">
              <div class="slick-carousel">
                <div>
                  <img src="/img/Studio/1.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Studio/2.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Studio/3.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Studio/4.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Studio/5.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Studio/6.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Studio/7.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Studio/8.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Studio/9.jpg" alt="">
                </div>
                <div>
                  <img src="/img/Studio/10.jpg" alt="">
                </div>
              </div>
                <div class="m-slider">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img data-src="img/studio-m/1.jpg" class="swiper-lazy" alt="Студия">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/studio-m/2.jpg" class="swiper-lazy" alt="Студия (2)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/studio-m/3.jpg" class="swiper-lazy" alt="Студия (3)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/studio-m/4.jpg" class="swiper-lazy" alt="Студия (4)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/studio-m/5.jpg" class="swiper-lazy" alt="Студия (5)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/studio-m/6.jpg" class="swiper-lazy" alt="Студия (6)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/studio-m/7.jpg" class="swiper-lazy" alt="Студия (7)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/studio-m/8.jpg" class="swiper-lazy" alt="Студия (8)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/studio-m/9.jpg" class="swiper-lazy" alt="Студия (9)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/studio-m/10.jpg" class="swiper-lazy" alt="Студия (10)">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                        </div>
                        <!-- Add Pagination -->
                        <div class="swiper-pagination swiper-pagination-white"></div>
                    </div>
                </div>
            </div>
            <div class="room">
                <div class="content">
                    <h2 class="content-title">{{$t('roomStudio.title')}}</h2>
                    <p class="content-description">
                        {{$t('roomStudio.textTop')}}
                    </p>
                    <div class="room-info">
                        <!--<div class="room-info-content">-->
                        <!--<h4 class="room-info-title">Цена</h4>-->
                        <!--<p>1635 <span>грн</span></p>-->
                        <!--</div>-->
                        <div class="room-info-content">
                            <div class="room-info-title">{{$t('roomStudio.areaTitle')}}</div>
                            <p>42 <span>{{$t('roomStudio.areaDescription')}}</span></p>
                        </div>
                        <div class="room-info-content">
                            <div class="room-info-title">{{$t('roomStudio.guests')}}</div>
                            <p>1-4 <span>{{$t('roomStudio.guestDescription')}}</span></p>
                        </div>
                    </div>
                    <div class="content-buttons">
                        <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`] + '?room-type=17709'" class="orange-btn">{{$t('buttons.btn1')}}</a>
                        <a href="#modal_studio" class="border-btn open-modal" @click="viewItem({ id: 17709, name: 'Студія' })">{{$t('buttons.more')}}</a>
                        <div class="m-buttons-wrap">
                            <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`] + '?room-type=17709'" class="orange-btn">{{$t('buttons.btn1')}}</a>
                            <a
                                href="#modal_lux"
                                class="border-btn open-modal"
                                @click="
                                  changeButtonText('studio')
                                  details_opened.studio ? viewItem({ id: 17709, name: 'Студія' }) : () => {}
                                "
                            >
                                {{details_opened.studio ? $t('buttons.hide') : $t('buttons.more')}}
                            </a>
                        </div>
                        <div class="accordion">
                            <div class="in-number">
                                <h2 class="title">{{$t('accommodation.accommodation')}}</h2>
                                <p>
                                    {{$t('accommodation.kingsize')}},
                                    {{$t('accommodation.sofa')}},
                                    {{$t('accommodation.table')}},
                                    {{$t('accommodation.secretaire')}},
                                    {{$t('accommodation.conditioner')}},
                                    {{$t('accommodation.tv')}},
                                    {{$t('accommodation.telephone')}},
                                    {{$t('accommodation.safe')}},
                                    {{$t('accommodation.minibar')}},
                                    {{$t('accommodation.luggage')}},
                                    {{$t('accommodation.hangers')}},
                                    {{$t('accommodation.chair')}},
                                    {{$t('accommodation.wardrobe')}},
                                    {{$t('accommodation.mirror_big')}},
                                    {{$t('accommodation.wifi')}}
                                </p>
                            </div>
                            <div class="in-bathroom">
                                <h2 class="title">{{$t('bathroom.bathroom')}}</h2>
                                <p>
                                    {{$t('bathroom.shower')}},
                                    {{$t('bathroom.hairdryer')}},
                                    {{$t('bathroom.towels')}},
                                    {{$t('bathroom.bath robes')}},
                                    {{$t('bathroom.slippers')}},
                                    {{$t('bathroom.toiletries')}}
                                </p>
                            </div>
                            <div class="info">
                                <h2 class="title">{{$t('services.services')}}</h2>
                                <p>
                                    {{$t('services.arrival')}},
                                    {{$t('services.departure')}},
                                    {{$t('services.concierge')}},
                                    {{$t('services.laundry')}},
                                    {{$t('services.restaurant_full')}},
                                    {{$t('services.lobby')}},
                                    {{$t('services.roomService')}},
                                    {{$t('services.conferenceService')}},
                                    {{$t('services.mall')}}
                                </p>
                            </div>
                            <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`] + '?room-type=17709'" class="mob-reserv">{{$t('buttons.btn1')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="room-section white-bg">
            <div class="room">
                <div class="content">
                    <h2 class="content-title">{{$t('roomFamily.title')}}</h2>
                    <p class="content-description">
                        {{$t('roomFamily.textTop')}}
                    </p>
                    <div class="room-info">
                        <div class="room-info-content">
                            <h4 class="room-info-title">{{$t('roomFamily.areaTitle')}}</h4>
                            <p>64 <span>{{$t('roomFamily.areaDescription')}}</span></p>
                        </div>
                        <div class="room-info-content">
                            <h4 class="room-info-title">{{$t('roomFamily.guests')}}</h4>
                            <p>1-4 <span>{{$t('roomFamily.guestDescription')}}</span></p>
                        </div>
                    </div>
                    <div class="content-buttons">
                        <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]  + '?room-type=105030'" class="orange-btn">{{$t('buttons.btn1')}}</a>
                        <a href="#modal_family" class="border-btn open-modal" @click="viewItem({ id: 105030, name: 'Сімейний люкс' })">{{$t('buttons.more')}}</a>
                        <div class="m-buttons-wrap">
                            <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]  + '?room-type=105030'" class="orange-btn">{{$t('buttons.btn1')}}</a>
                            <a
                                href="#modal_family"
                                class="border-btn open-modal"
                                @click="
                                  changeButtonText('suite')
                                  details_opened.suite ? viewItem({ id: 105030, name: 'Сімейний люкс' }) : () => {}
                                "
                            >
                                {{details_opened.suite ? $t('buttons.hide') : $t('buttons.more')}}
                            </a>
                        </div>
                        <div class="accordion">
                            <div class="in-number">
                                <h2 class="title">{{$t('accommodation.accommodation')}}</h2>
                                <p>
                                    {{$t('accommodation.kingsize')}},
                                    {{$t('accommodation.sofa')}},
                                    {{$t('accommodation.table')}},
                                    {{$t('accommodation.secretaire')}},
                                    {{$t('accommodation.conditioner')}},
                                    {{$t('accommodation.tv')}},
                                    {{$t('accommodation.telephone')}},
                                    {{$t('accommodation.safe')}},
                                    {{$t('accommodation.minibar')}},
                                    {{$t('accommodation.luggage')}},
                                    {{$t('accommodation.hangers')}},
                                    {{$t('accommodation.chair')}},
                                    {{$t('accommodation.wardrobe')}},
                                    {{$t('accommodation.mirror_big')}},
                                    {{$t('accommodation.wifi')}}
                                </p>
                            </div>
                            <div class="in-bathroom">
                                <h2 class="title">{{$t('bathroom.bathroom')}}</h2>
                                <p>
                                    {{$t('bathroom.shower')}} /
                                    {{$t('bathroom.bathroom')}},
                                    {{$t('bathroom.hairdryer')}},
                                    {{$t('bathroom.towels')}},
                                    {{$t('bathroom.bath robes')}},
                                    {{$t('bathroom.slippers')}},
                                    {{$t('bathroom.toiletries')}}
                                </p>
                            </div>
                            <div class="info">
                                <h2 class="title">{{$t('services.services')}}</h2>
                                <p>
                                    {{$t('services.arrival')}},
                                    {{$t('services.departure')}},
                                    {{$t('services.concierge')}},
                                    {{$t('services.laundry')}},
                                    {{$t('services.restaurant_full')}},
                                    {{$t('services.lobby')}},
                                    {{$t('services.roomService')}},
                                    {{$t('services.conferenceService')}},
                                    {{$t('services.mall')}}
                                </p>
                            </div>
                            <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]  + '?room-type=105030'" class="mob-reserv">{{$t('buttons.btn1')}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="room room-image-family">
              <div class="slick-carousel">
                <div>
                  <img src="/img/family/1.jpg" alt="">
                </div>
                <div>
                  <img src="/img/family/2.jpg" alt="">
                </div>
                <div>
                  <img src="/img/family/3.jpg" alt="">
                </div>
                <div>
                  <img src="/img/family/4.jpg" alt="">
                </div>
                <div>
                  <img src="/img/family/5.jpg" alt="">
                </div>
                <div>
                  <img src="/img/family/6.jpg" alt="">
                </div>
                <div>
                  <img src="/img/family/7.jpg" alt="">
                </div>
                <div>
                  <img src="/img/family/8.jpg" alt="">
                </div>
              </div>
                <div class="m-slider">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img data-src="img/family/4.jpg" class="swiper-lazy">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/family/2.jpg" class="swiper-lazy">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/family/3.jpg" class="swiper-lazy">
                                <div class="swiper-lazy-preloader swijpg-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/family/5.jpg" class="swiper-lazy">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/family/6.jpg" class="swiper-lazy">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/family/7.jpg" class="swiper-lazy">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/family/8.jpg" class="swiper-lazy">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                            <div class="swiper-slide">
                                <img data-src="img/family/1.jpg" class="swiper-lazy">
                                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                            </div>
                        </div>
                        <!-- Add Pagination -->
                        <div class="swiper-pagination swiper-pagination-white"></div>
                    </div>

                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import Mixins from "@/mixins/mixins.js"
    export default {
       name:'Rooms',
        mixins: [Mixins],
        data() {
            return {
                details_opened: {
                    standart: false,
                    deluxe: false,
                    suite: false,
                    studio: false,
                    family: false
                }
            }
        },
        computed: {
            lang: function() {
                return this.$root.locale;
            },
        },
        methods: {
            changeButtonText(room) {
                this.details_opened[room] = !this.details_opened[room];
            },
            viewItem(data) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push({
                event: "view_item",
                ecommerce: {
                  items: [{
                    item_name: data.name,
                    item_id: data.id,
                    price: "??",
                    item_brand: "Gagarinn",
                    item_category: "Номер",
                    quantity: 1
                  }]
                }
            });

    }
        },
        created(){
           console.log(this.isMobile());
        }
    }
</script>
